(function () {
	'use strict';

	// Floating labels for CF7 forms.
	function initFloatingLabels(root = document) {
		const labels = root.querySelectorAll('label.float-label');
		labels.forEach((label) => {
			// Find inputs / textareas inside the label.
			const fields = label.querySelectorAll('input, textarea, select');
			if (!fields.length) return;

			function update(labelEl, fieldEl) {
				const hasValue = fieldEl.value && fieldEl.value.trim() !== '';
				if (hasValue) {
					labelEl.classList.add('filled');
				} else {
					labelEl.classList.remove('filled');
				}
			}

			fields.forEach((field) => {
				// On input/change/blur update state.
				['input', 'change', 'blur'].forEach((evt) =>
					field.addEventListener(evt, () => update(label, field))
				);
				// Initial pass.
				update(label, field);
				// Delayed pass for Chrome autofill.
				setTimeout(() => update(label, field), 150);
			});
		});
	}

	// Run on DOM ready.
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initFloatingLabels());
	} else {
		initFloatingLabels();
	}

	// CF7 re-renders forms on Ajax submit; listen to its events if available.
	document.addEventListener('wpcf7mailsent', () => initFloatingLabels());
	document.addEventListener('wpcf7invalid', () => initFloatingLabels());
	document.addEventListener('wpcf7spam', () => initFloatingLabels());
	document.addEventListener('wpcf7submit', () => initFloatingLabels());

	// MutationObserver fallback in case forms are injected later.
	const mo = new MutationObserver((muts) => {
		for (const m of muts) {
			if (m.addedNodes.length) {
				initFloatingLabels();
				break;
			}
		}
	});
	mo.observe(document.documentElement, { childList: true, subtree: true });

	// Slick slider
	setTimeout(() => {
		document
			.querySelectorAll('.wp-block-gb-for-slick-slider-slick-slider.is-style-multiple-items')
			.forEach(function (slider) {
				const sliderInstance = jQuery(slider);
				// Add custom class to next or previous slide depending on change direction
				sliderInstance.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
					let nextIndex = currentSlide + 1; // assume moving right
					if (
						currentSlide - 1 == nextSlide ||
						(nextSlide + 1 == slick.slideCount && currentSlide < nextSlide)
					) {
						nextIndex = currentSlide - 1; // nope, moving left
					}
					slider
						.querySelector(`[data-slick-index="${nextIndex}"]`)
						?.classList.add('slick-target');
				});

				// clear custom class after transition
				sliderInstance.on('afterChange', () => {
					slider
						.querySelectorAll('.slick-slide')
						.forEach((slide) => slide.classList.remove('slick-target'));
				});
			});
	}, 500);

	// iFrame resizing
	var iframeElement = document.getElementsByClassName('o-iframe-wrapper__iframe');
	if (iframeElement.length !== 0) {
		let iframe = iframeElement[0];
		let resizeHandler = function () {
			if (iframe !== null) {
				var width = window.innerWidth;
				if (width < 667) {
					iframe.height = '1700';
				} else {
					iframe.height = '1150';
				}
			}
		};
		window.addEventListener('resize', resizeHandler);
		resizeHandler();
	}

	// if any li within the header element has a hovered state, add the class hovered to parent header
	var headerElement = document.getElementsByTagName('header');
	if (headerElement.length !== 0) {
		let header = headerElement[0];
		let navItems = header.querySelectorAll('li');
		navItems.forEach((item) => {
			item.addEventListener('mouseenter', () => {
				header.classList.add('hovered');
			});
			item.addEventListener('mouseleave', () => {
				header.classList.remove('hovered');
			});
		});
	}

	// Hide .mega-menu-description and copy the text into a tooltip attribute on .mega-menu-link
	var megaMenuDescriptions = document.getElementsByClassName('mega-menu-description');
	Array.from(megaMenuDescriptions).forEach(function (desc) {
		var menuLink = desc.closest('.mega-menu-link');
		if (menuLink) {
			menuLink.setAttribute('title', desc.textContent.trim());
			desc.style.display = 'none';
		}
	});
})();
